var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownAnimatedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 200,
      height: 200
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n     .line-arrow-down2 {animation:line-arrow-down2-move 1.6s infinite;}\n     @keyframes line-arrow-down2-move {\n         0%{transform: translate3d(0, -2px, 0);}\n         50%{transform: translate3d(0, 2px, 0);}\n         100%{transform: translate3d(0, -2px, 0);}\n     }\n     @media (prefers-reduced-motion: reduce) {\n         .line-arrow-down2 {\n             animation: none;\n         }\n     }\n    ")), /*#__PURE__*/React.createElement("path", {
    className: "line-arrow-down2 stroke1",
    id: "a",
    d: "M48.9919 5L48.9919 95M48.9919 95L85 59.1525M48.9919 95L13.75 59.1525",
    stroke: "#000",
    strokeWidth: "4.0px",
    strokeLinecap: "round",
    style: {
      animationDuration: "1.6s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownAnimatedDark);
export default __webpack_public_path__ + "static/media/arrow-down-animated-dark.7577df8b4a5ce76c41b9f299d937d58d.svg";
export { ForwardRef as ReactComponent };